import { useEffect, useState } from 'react';

/** Tracks scroll position and progress bar percentage. */
export function useNavScroll() {
  const [scrolled, setScrolled]         = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 60);
      const total = document.documentElement.scrollHeight - window.innerHeight;
      setScrollProgress(total > 0 ? (y / total) * 100 : 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
    // onScroll/y/total are defined inside this effect; setState dispatchers are stable
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { scrolled, scrollProgress };
}
